import { Fragment, useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  addDoc,
  collection,
  getDocs,
  query,
  where,
  serverTimestamp,
  limit,
  doc,
  updateDoc,
} from "firebase/firestore";
import { db } from "../../firebase";

const initialForm = {
  previousVisit: "",
  vpjcId: "",
  tokenNumber: "",
  tokenDate: "",
  tokenBranch: "",
  visitId: "",
  name: "",
  age: "",
  gender: "",
  guardianName: "",
  maritalStatus: "",
  nationality: "",
  occupation: "",
  bloodGroup: "",
  patientType: "",
  patientCategory: "",
  paymentMode: "",
  isMLC: "",
  emergencyContactPerson: "",
  emergencyContactNumber: "",
  referringDoctorHospital: "",
  residentialAddress: "",
  residentialCity: "",
  residentialState: "",
  residentialPin: "",
  residentialPhone: "",
  residentialMobile: "",
  residentialEmail: "",
  permanentAddress: "",
  permanentCity: "",
  permanentState: "",
  permanentPin: "",
  permanentPhone: "",
  permanentMobile: "",
  permanentEmail: "",
  sponsorName: "",
  referralLetterDate: "",
  referralLetterNumber: "",
  groupNumber: "",
  policyNumber: "",
  employeeCode: "",
  employeeName: "",
  employeeRelation: "",
  basicSalary: "",
  referralStartDate: "",
  referralEndDate: "",
  patientSignature: "",
  registeredBy: "",
};

const sections = [
  {
    title: "Patient Details",
    teTitle: "రోగి వివరాలు",
    fields: [
      {
        name: "previousVisit",
        label: "Have you visited VPJC before?",
        teLabel: "మీరు ఇంతకుముందు VPJC కి వచ్చారా?",
        type: "radio",
        options: ["Yes", "No"],
        teOptions: ["అవును", "కాదు"],
        required: true,
      },
      {
        name: "vpjcId",
        label: "Patient VPJC ID",
        teLabel: "VPJC రోగి ఐడి",
        required: true,
      },
      {
        name: "name",
        label: "Patient Name (Mr./Mrs./Miss)",
        teLabel: "రోగి పేరు",
        required: true,
      },
      {
        name: "age",
        label: "Age",
        teLabel: "వయస్సు",
        type: "number",
        required: true,
      },
      {
        name: "gender",
        label: "Gender",
        teLabel: "లింగం",
        type: "select",
        options: ["Male", "Female", "Other"],
        teOptions: ["పురుషుడు", "స్త్రీ", "ఇతరులు"],
        required: true,
      },
      {
        name: "guardianName",
        label: "Father's / Husband's Name",
        teLabel: "తండ్రి / భర్త పేరు",
      },
      {
        name: "maritalStatus",
        label: "Marital Status",
        teLabel: "వైవాహిక స్థితి",
        type: "radio",
        options: ["Single", "Married"],
        teOptions: ["అవివాహితులు", "వివాహితులు"],
      },
      {
        name: "nationality",
        label: "Nationality",
        teLabel: "జాతీయత",
      },
      {
        name: "occupation",
        label: "Occupation",
        teLabel: "వృత్తి",
      },
      {
        name: "bloodGroup",
        label: "Blood Group",
        teLabel: "రక్త వర్గం",
        type: "select",
        options: [
          "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "Unknown",
        ],
        teOptions: [
          "A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-", "తెలియదు",
        ],
      },
      {
        name: "patientType",
        label: "Patient Type",
        teLabel: "రోగి రకం",
        type: "radio",
        options: ["IP", "OP"],
        teOptions: ["IP (ఇన్‌పేషెంట్)", "OP (అవుట్‌పేషెంట్)"],
        required: true,
      },
      {
        name: "patientCategory",
        label: "Patient Category",
        teLabel: "రోగి విభాగం",
        type: "radio",
        options: ["Cash", "Sponsor"],
        teOptions: ["నగదు", "స్పాన్సర్"],
        required: true,
      },
      {
        name: "paymentMode",
        label: "Payment Mode",
        teLabel: "చెల్లింపు విధానం",
        type: "radio",
        options: ["Cash", "Online"],
        teOptions: ["నగదు", "ఆన్‌లైన్"],
        required: true,
      },
    ],
  },
 
{
  title: "Reference Information",
  teTitle: "సూచన వివరాలు",
  fields: [
    {
      name: "isMLC",
      label: "Is this a Medico-Legal Case (MLC)?",
      teLabel: "MLC కేసా?",
      type: "radio",
      options: ["Yes", "No"],
      teOptions: ["అవును", "కాదు"],
    },
    {
      name: "emergencyContactPerson",
      label: "Emergency Contact Person",
      teLabel: "అత్యవసర సంప్రదింపు వ్యక్తి",
    },
    {
      name: "emergencyContactNumber",
      label: "Emergency Contact Number",
      teLabel: "అత్యవసర సంప్రదింపు నంబర్",
      type: "tel",
    },
    {
      name: "referringDoctorHospital",
      label: "Referring Doctor / Hospital",
      teLabel: "సూచించిన వైద్యుడు / ఆసుపత్రి",
      full: true,
    },
  ],
},
{
  title: "Address Information",
  teTitle: "చిరునామా వివరాలు",
  fields: [
    {
      name: "residentialAddress",
      label: "Residential Address",
      teLabel: "ప్రస్తుత చిరునామా",
      full: true,
    },
    {
      name: "residentialCity",
      label: "Village / City",
      teLabel: "గ్రామం / నగరం",
    },
    {
      name: "residentialState",
      label: "State",
      teLabel: "రాష్ట్రం",
    },
    {
      name: "residentialPin",
      label: "PIN Code",
      teLabel: "పిన్ కోడ్",
    },
    {
      name: "residentialPhone",
      label: "Phone Number",
      teLabel: "ఫోన్ నంబర్",
      type: "tel",
    },
    {
      name: "residentialMobile",
      label: "Mobile Number",
      teLabel: "మొబైల్ నంబర్",
      type: "tel",
    },
    {
      name: "residentialEmail",
      label: "Email",
      teLabel: "ఈమెయిల్",
      type: "email",
    },
    {
      name: "permanentAddress",
      label: "Permanent Address",
      teLabel: "శాశ్వత చిరునామా",
      full: true,
    },
    {
      name: "permanentCity",
      label: "Village / City",
      teLabel: "గ్రామం / నగరం",
    },
    {
      name: "permanentState",
      label: "State",
      teLabel: "రాష్ట్రం",
    },
    {
      name: "permanentPin",
      label: "PIN Code",
      teLabel: "పిన్ కోడ్",
    },
    {
      name: "permanentPhone",
      label: "Phone Number",
      teLabel: "ఫోన్ నంబర్",
      type: "tel",
    },
    {
      name: "permanentMobile",
      label: "Mobile Number",
      teLabel: "మొబైల్ నంబర్",
      type: "tel",
    },
    {
      name: "permanentEmail",
      label: "Email",
      teLabel: "ఈమెయిల్",
      type: "email",
    },
  ],
},
{
  title: "Insurance / Sponsor Information",
  teTitle: "బీమా / స్పాన్సర్ వివరాలు",
  fields: [
    {
      name: "sponsorName",
      label: "Sponsor Name",
      teLabel: "స్పాన్సర్ పేరు",
    },
    {
      name: "referralLetterDate",
      label: "Referral Letter Date",
      teLabel: "రిఫరల్ లేఖ తేదీ",
      type: "date",
    },
    {
      name: "referralLetterNumber",
      label: "Referral Letter Number",
      teLabel: "రిఫరల్ లేఖ నంబర్",
    },
    {
      name: "groupNumber",
      label: "Group Number",
      teLabel: "గ్రూప్ నంబర్",
    },
    {
      name: "policyNumber",
      label: "Policy Number",
      teLabel: "పాలసీ నంబర్",
    },
    {
      name: "employeeCode",
      label: "Employee Code",
      teLabel: "ఉద్యోగి కోడ్",
    },
    {
      name: "employeeName",
      label: "Employee Name",
      teLabel: "ఉద్యోగి పేరు",
    },
    {
      name: "employeeRelation",
      label: "Employee Relation",
      teLabel: "ఉద్యోగితో సంబంధం",
    },
    {
      name: "basicSalary",
      label: "Basic Salary",
      teLabel: "ప్రాథమిక జీతం",
      type: "text",
      inputMode: "numeric",
    },
    {
      name: "referralStartDate",
      label: "Referral Start Date",
      teLabel: "రిఫరల్ ప్రారంభ తేదీ",
      type: "date",
    },
    {
      name: "referralEndDate",
      label: "Referral End Date",
      teLabel: "రిఫరల్ ముగింపు తేదీ",
      type: "date",
    },
  ],
},
{
  title: "Registration & Office Use",
  teTitle: "నమోదు మరియు కార్యాలయ వినియోగం",
  fields: [
    {
      name: "patientSignature",
      label: "Patient / Guardian Signature",
      teLabel: "రోగి / సంరక్షకుని సంతకం",
      type: "signature",
      full: true,
    },
    {
      name: "registeredBy",
      label: "Patient Registered By",
      teLabel: "నమోదు చేసిన వ్యక్తి",
    },
  ],
},
];

export default function PatientRegistration() {
    const navigate = useNavigate();
    const location = useLocation();
    const [form, setForm] = useState(initialForm);
    const [saving, setSaving] = useState(false);
    const [message, setMessage] = useState("");
    const [messageType, setMessageType] = useState("success");
    const [fieldErrors, setFieldErrors] = useState({});
  const [language, setLanguage] = useState("en");
  const [patientLookupStatus, setPatientLookupStatus] = useState("");
  const [fetchingPatient, setFetchingPatient] = useState(false);
  const [lookupInput, setLookupInput] = useState("");
  const [lookupResults, setLookupResults] = useState([]);
  const [selectedRegistrationId, setSelectedRegistrationId] = useState("");
  const [selectedExistingPatient, setSelectedExistingPatient] = useState(false);
  const [tokenConfirmation, setTokenConfirmation] = useState(null);
  const [sameAsResidential, setSameAsResidential] = useState(false);
  const consumedTokenState = useRef(false);
  const signatureCanvasRef = useRef(null);
  const signatureDrawingRef = useRef(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const startSignature = (event) => {
    const canvas = signatureCanvasRef.current;
    if (!canvas) return;

    const rect = canvas.getBoundingClientRect();
    const context = canvas.getContext("2d");
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    context.beginPath();
    context.moveTo(
      (event.clientX - rect.left) * scaleX,
      (event.clientY - rect.top) * scaleY
    );
    context.lineWidth = 3;
    context.lineCap = "round";
    context.lineJoin = "round";
    context.strokeStyle = "#172554";
    signatureDrawingRef.current = true;
    canvas.setPointerCapture?.(event.pointerId);
  };

  const drawSignature = (event) => {
    const canvas = signatureCanvasRef.current;
    if (!canvas || !signatureDrawingRef.current) return;

    const rect = canvas.getBoundingClientRect();
    const context = canvas.getContext("2d");
    const scaleX = canvas.width / rect.width;
    const scaleY = canvas.height / rect.height;

    context.lineTo(
      (event.clientX - rect.left) * scaleX,
      (event.clientY - rect.top) * scaleY
    );
    context.stroke();
  };

  const finishSignature = () => {
    const canvas = signatureCanvasRef.current;
    if (!canvas || !signatureDrawingRef.current) return;

    signatureDrawingRef.current = false;
    setForm((prev) => ({
      ...prev,
      patientSignature: canvas.toDataURL("image/png"),
    }));
  };

  const clearSignature = () => {
    const canvas = signatureCanvasRef.current;
    if (canvas) {
      const context = canvas.getContext("2d");
      context.clearRect(0, 0, canvas.width, canvas.height);
    }
    setForm((prev) => ({ ...prev, patientSignature: "" }));
  };

  const updateField = (name, value) => {
    setForm((prev) => ({ ...prev, [name]: value }));
    if (name === "previousVisit") {
      setLookupResults([]);
      setPatientLookupStatus("");
      setSelectedRegistrationId("");
      setSelectedExistingPatient(false);
      if (value === "Yes") setTokenConfirmation(null);
    }
    if (fieldErrors[name]) {
      setFieldErrors((prev) => {
        const next = { ...prev };
        delete next[name];
        if (Object.keys(next).length === 0) setMessage("");
        return next;
      });
    }
  };

  // Receive the token generated by /token and restore the registration draft.
  useEffect(() => {
    const returned = location.state?.tokenRegistrationResult;
    const draft = location.state?.registrationDraft;

    if (!returned || consumedTokenState.current) return;
    consumedTokenState.current = true;

    setForm((prev) => ({
      ...initialForm,
      ...(draft || {}),
      previousVisit: "No",
      vpjcId: returned.vpjcId || draft?.vpjcId || "",
      name: returned.name || draft?.name || "",
      residentialMobile: returned.mobile || draft?.residentialMobile || "",
      tokenNumber: returned.token || "",
      tokenDate: returned.tokenDate || returned.date || "",
      tokenBranch: returned.branchName || "",
      visitId: returned.visitId || "",
    }));
    setTokenConfirmation(returned);
    setPatientLookupStatus(
      language === "te"
        ? "టోకెన్ విజయవంతంగా రూపొందించబడింది. ఇప్పుడు రిజిస్ట్రేషన్ పూర్తి చేయండి."
        : "Token generated successfully. Complete the patient registration below."
    );
    setSelectedExistingPatient(false);
    setSelectedRegistrationId("");

    // Remove transient router state after consuming it.
    navigate(location.pathname, { replace: true, state: null });
  }, [location.key]);

  const applyPatientDetails = (patient) => {
    const getValue = (...keys) => {
      for (const key of keys) {
        const value = patient?.[key];
        if (value !== undefined && value !== null && value !== "") return value;
      }
      return "";
    };

    setForm((prev) => ({
      ...prev,
      previousVisit: "Yes",
      vpjcId: getValue("vpjc_id", "vpjcId") || prev.vpjcId,
      name: getValue("name", "patient_name") || prev.name,
      age: getValue("age") !== "" ? String(getValue("age")) : prev.age,
      gender: getValue("gender") || prev.gender,
      guardianName: getValue("guardianName", "guardian_name", "father_name") || prev.guardianName,
      maritalStatus: getValue("maritalStatus", "marital_status") || prev.maritalStatus,
      nationality: getValue("nationality") || prev.nationality,
      occupation: getValue("occupation") || prev.occupation,
      bloodGroup: getValue("bloodGroup", "blood_group") || prev.bloodGroup,
      patientType: getValue("patientType", "patient_type") || prev.patientType,
      patientCategory: getValue("patientCategory", "patient_category") || prev.patientCategory,
      paymentMode: getValue("paymentMode", "payment_mode") || prev.paymentMode,
      residentialAddress: getValue("residentialAddress", "residential_address", "address") || prev.residentialAddress,
      residentialCity: getValue("residentialCity", "residential_city", "city") || prev.residentialCity,
      residentialState: getValue("residentialState", "residential_state", "state") || prev.residentialState,
      residentialPin: getValue("residentialPin", "residential_pin", "pincode", "pin") || prev.residentialPin,
      residentialMobile: getValue("mobile", "residentialMobile", "residential_mobile") || prev.residentialMobile,
      residentialPhone: getValue("residentialPhone", "residential_phone", "phone") || prev.residentialPhone,
      residentialEmail: getValue("email", "residentialEmail", "residential_email") || prev.residentialEmail,
      permanentAddress: getValue("permanentAddress", "permanent_address") || prev.permanentAddress,
      permanentCity: getValue("permanentCity", "permanent_city") || prev.permanentCity,
      permanentState: getValue("permanentState", "permanent_state") || prev.permanentState,
      permanentPin: getValue("permanentPin", "permanent_pin") || prev.permanentPin,
      permanentMobile: getValue("permanentMobile", "permanent_mobile") || prev.permanentMobile,
      permanentPhone: getValue("permanentPhone", "permanent_phone") || prev.permanentPhone,
      permanentEmail: getValue("permanentEmail", "permanent_email") || prev.permanentEmail,
      sponsorName: getValue("sponsorName", "sponsor_name") || prev.sponsorName,
      referralLetterDate: getValue("referralLetterDate", "referral_letter_date") || prev.referralLetterDate,
      referralLetterNumber: getValue("referralLetterNumber", "referral_letter_number") || prev.referralLetterNumber,
      groupNumber: getValue("groupNumber", "group_number") || prev.groupNumber,
      policyNumber: getValue("policyNumber", "policy_number") || prev.policyNumber,
      employeeCode: getValue("employeeCode", "employee_code") || prev.employeeCode,
      employeeName: getValue("employeeName", "employee_name") || prev.employeeName,
      employeeRelation: getValue("employeeRelation", "employee_relation") || prev.employeeRelation,
      basicSalary: getValue("basicSalary", "basic_salary") !== "" ? String(getValue("basicSalary", "basic_salary")) : prev.basicSalary,
      referralStartDate: getValue("referralStartDate", "referral_start_date") || prev.referralStartDate,
      referralEndDate: getValue("referralEndDate", "referral_end_date") || prev.referralEndDate,
    }));

    setSelectedRegistrationId(patient._registrationDocId || "");
    setSelectedExistingPatient(true);
    setTokenConfirmation(null);
    setPatientLookupStatus(
      language === "te"
        ? "రోగి వివరాలు విజయవంతంగా పొందబడ్డాయి."
        : "Patient details fetched successfully."
    );
    setLookupResults([]);
  };

  const searchExistingPatient = async () => {
    const value = lookupInput.trim();
    const isId = /^VPJC-\d{6}$/i.test(value);
    const isMobile = /^[6-9]\d{9}$/.test(value);

    if (!isId && !isMobile) {
      setPatientLookupStatus(
        language === "te"
          ? "సరైన VPJC ID లేదా 10 అంకెల మొబైల్ నంబర్ నమోదు చేయండి."
          : "Enter a valid VPJC ID or 10-digit mobile number."
      );
      return;
    }

    setFetchingPatient(true);
    setLookupResults([]);
    setPatientLookupStatus(
      language === "te" ? "రోగి వివరాలు వెతుకుతున్నాము..." : "Searching patients..."
    );

    try {
      const patientQuery = query(
        collection(db, "patients"),
        where(isId ? "vpjc_id" : "mobile", "==", isId ? value.toUpperCase() : value)
      );
      const patientSnapshot = await getDocs(patientQuery);

      let patientRecords = patientSnapshot.docs.map((patientDoc) => ({
        _patientDocId: patientDoc.id,
        ...patientDoc.data(),
      }));

      // Older visit records may exist even if a patient profile was not migrated.
      if (patientRecords.length === 0) {
        const legacyVisitQuery = query(
          collection(db, "visits"),
          where(isId ? "vpjc_id" : "mobile", "==", isId ? value.toUpperCase() : value)
        );
        const legacyVisits = await getDocs(legacyVisitQuery);
        const uniquePatients = new Map();
        legacyVisits.docs.forEach((visitDoc) => {
          const visit = visitDoc.data();
          const key = visit.vpjc_id || visit.patient_id || visitDoc.id;
          if (!uniquePatients.has(key)) {
            uniquePatients.set(key, {
              ...visit,
              _patientDocId: visit.patient_id || key,
            });
          }
        });
        patientRecords = Array.from(uniquePatients.values());
      }

      if (patientRecords.length === 0) {
        setPatientLookupStatus(
          language === "te"
            ? "రోగి వివరాలు కనుగొనబడలేదు."
            : "No patient found. Please check the ID or mobile number."
        );
        return;
      }

      const candidates = await Promise.all(
        patientRecords.map(async (base) => {
          const registrationQuery = query(
            collection(db, "patients_regisgistration_form"),
            where("vpjc_id", "==", base.vpjc_id),
            limit(1)
          );
          const registrationSnapshot = await getDocs(registrationQuery);
          if (registrationSnapshot.empty) return base;
          const registrationDoc = registrationSnapshot.docs[0];
          return {
            ...base,
            ...registrationDoc.data(),
            _patientDocId: base._patientDocId,
            _registrationDocId: registrationDoc.id,
          };
        })
      );

      if (candidates.length === 1) {
        applyPatientDetails(candidates[0]);
      } else {
        setLookupResults(candidates);
        setPatientLookupStatus(
          language === "te"
            ? "ఒకటి కంటే ఎక్కువ రికార్డులు ఉన్నాయి. సరైన రోగిని ఎంచుకోండి."
            : "Multiple records found. Please select the correct patient."
        );
      }
    } catch (error) {
      console.error("Patient search error:", error);
      setPatientLookupStatus(
        language === "te"
          ? "రోగి వివరాలను పొందలేకపోయాము. మళ్లీ ప్రయత్నించండి."
          : "Unable to fetch patient details. Please try again."
      );
    } finally {
      setFetchingPatient(false);
    }
  };

  const inputClass =
    "w-full min-h-11 rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm outline-none transition focus:border-[#204080] focus:ring-2 focus:ring-blue-100";

  const renderField = (field) => (
    <div
      key={field.name}
      className={field.full ? "md:col-span-2 xl:col-span-3" : ""}
    >
      <label
        htmlFor={field.name}
        className="mb-2 block text-sm font-medium text-slate-700"
      >
        {language === "te"
        ? field.teLabel || field.label
        : field.label}
        {field.required && <span className="ml-1 text-red-600">*</span>}
      </label>

      {field.type === "signature" ? (
        <div className="space-y-2">
          <div className="overflow-hidden rounded-xl border border-slate-300 bg-white">
            <canvas
              ref={signatureCanvasRef}
              width={1000}
              height={240}
              onPointerDown={startSignature}
              onPointerMove={drawSignature}
              onPointerUp={finishSignature}
              onPointerCancel={finishSignature}
              className="block h-36 w-full touch-none cursor-crosshair sm:h-44"
              aria-label="Draw patient or guardian signature"
            />
          </div>
          <div className="flex items-center justify-between gap-3">
            <p className="text-xs text-slate-500">
              {language === "te"
                ? "పై బాక్స్‌లో సంతకం చేయండి."
                : "Draw the signature inside the box above."}
            </p>
            <button
              type="button"
              onClick={clearSignature}
              className="shrink-0 rounded-lg border border-slate-300 px-3 py-2 text-xs font-semibold text-slate-700 hover:bg-slate-50"
            >
              {language === "te" ? "తొలగించండి" : "Clear"}
            </button>
          </div>
        </div>
      ) : field.type === "radio" ? (
        <div className="flex min-h-11 flex-wrap items-center gap-x-5 gap-y-2">
          {field.options.map((option, index) => (
            <label
              key={option}
              className="inline-flex min-h-10 cursor-pointer items-center gap-2 text-sm text-slate-700"
            >
              <input
                type="radio"
                name={field.name}
                value={option}
                checked={form[field.name] === option}
                required={field.required}
                onChange={() => updateField(field.name, option)}
                className="h-4 w-4 accent-[#204080]"
              />
              {language === "te"
                ? field.teOptions?.[index] || option
                : option}
            </label>
          ))}
        </div>
      ) : field.type === "select" ? (
        <select
          id={field.name}
          value={form[field.name]}
          required={field.required}
          onChange={(e) => updateField(field.name, e.target.value)}
          className={inputClass}
        >
          <option value="">
            {language === "te" ? "ఎంచుకోండి" : `Select ${field.label}`}
          </option>
         {field.options.map((option, index) => (
        <option key={option} value={option}>
            {language === "te"
            ? field.teOptions?.[index] || option
            : option}
        </option>
        ))}

        </select>
      ) : (
        <input
          id={field.name}
          type={
            ["residentialPhone", "residentialMobile",
             "permanentPhone", "permanentMobile",
             "emergencyContactNumber", "residentialPin",
             "permanentPin", "age", "basicSalary"].includes(field.name)
              ? "text"
              : field.type || "text"
          }
          inputMode={
            ["residentialPhone", "residentialMobile",
             "permanentPhone", "permanentMobile",
             "emergencyContactNumber", "residentialPin",
             "permanentPin", "age", "basicSalary"].includes(field.name)
              ? "numeric"
              : undefined
          }
          maxLength={
            ["residentialMobile", "permanentMobile",
             "emergencyContactNumber", "residentialPhone",
             "permanentPhone"].includes(field.name)
              ? 10
              : ["residentialPin", "permanentPin"].includes(field.name)
              ? 6
              : field.name === "age"
              ? 3
              : undefined
          }
          value={form[field.name]}
          required={field.required}
          min={field.type === "number" ? "0" : undefined}
          max={field.name === "age" ? "120" : undefined}
          step={field.name === "age" ? "1" : undefined}
          onChange={(e) => {
            let value = e.target.value;
            if (field.name === "vpjcId") {
              value = value.toUpperCase();
              setPatientLookupStatus("");
              setForm((prev) => ({
                ...prev,
                vpjcId: value,
                name: "",
                age: "",
                gender: "",
                residentialMobile: "",
                residentialPhone: "",
                residentialAddress: "",
                residentialCity: "",
                residentialState: "",
                residentialPin: "",
                residentialEmail: "",
              }));
              setFieldErrors((prev) => {
                const next = { ...prev };
                delete next.vpjcId;
                if (Object.keys(next).length === 0) setMessage("");
                return next;
              });
              return;
            }
            if (
              ["residentialPhone", "residentialMobile",
               "permanentPhone", "permanentMobile",
               "emergencyContactNumber", "residentialPin",
               "permanentPin", "age", "basicSalary"].includes(field.name)
            ) {
              value = value.replace(/\D/g, "");
              if (
                ["residentialMobile", "permanentMobile",
                 "emergencyContactNumber", "residentialPhone",
                 "permanentPhone"].includes(field.name)
              ) value = value.slice(0, 10);
              if (["residentialPin", "permanentPin"].includes(field.name)) {
                value = value.slice(0, 6);
              }
              if (field.name === "age") value = value.slice(0, 3);
            }
            updateField(field.name, value);
            if (fieldErrors[field.name]) {
              setFieldErrors((prev) => {
                const next = { ...prev };
                delete next[field.name];
                return next;
              });
            }
          }}
          className={inputClass}
        />
      )}
      {field.name === "vpjcId" && patientLookupStatus && (
        <p
          role="status"
          className={`mt-2 text-xs font-medium ${
            patientLookupStatus.toLowerCase().includes("successfully")
              ? "text-green-700"
              : patientLookupStatus.toLowerCase().includes("searching")
                ? "text-[#204080]"
                : "text-red-600"
          }`}
        >
          {fetchingPatient ? " " : ""}
          {patientLookupStatus}
        </p>
      )}

      {fieldErrors[field.name] && (
        <p className="mt-1 text-sm text-red-600" role="alert">
          {language === "te"
            ? ({
                previousVisit: "దయచేసి ఎంచుకోండి.",
                vpjcId: "దయచేసి సరైన VPJC రోగి ఐడిని నమోదు చేయండి.",
                name: "దయచేసి రోగి పేరు నమోదు చేయండి.",
                age: "దయచేసి సరైన వయస్సు నమోదు చేయండి.",
                gender: "దయచేసి లింగాన్ని ఎంచుకోండి.",
                patientType: "దయచేసి రోగి రకాన్ని ఎంచుకోండి.",
                patientCategory: "దయచేసి రోగి విభాగాన్ని ఎంచుకోండి.",
                paymentMode: "దయచేసి చెల్లింపు విధానాన్ని ఎంచుకోండి.",
                sponsorName: "దయచేసి స్పాన్సర్ పేరు నమోదు చేయండి.",
              }[field.name] || fieldErrors[field.name])
            : fieldErrors[field.name]}
        </p>
      )}
    </div>
  );

 

const handleSubmit = async (e) => {
  e.preventDefault();

  if (saving) return;

  setMessage("");
  setFieldErrors({});

  const validationMessage = (english, telugu) =>
    language === "te" ? telugu : english;

  const errors = {};

  // Required field validation
  const normalizedVpjcId = (form.vpjcId || "").trim().toUpperCase();
  if (!normalizedVpjcId) {
    errors.vpjcId = validationMessage(
      "Please enter the Patient VPJC ID.",
      "దయచేసి VPJC రోగి ఐడిని నమోదు చేయండి."
    );
  } else if (!/^VPJC-\d{6}$/.test(normalizedVpjcId)) {
    errors.vpjcId = validationMessage(
      "Enter a valid VPJC ID (example: VPJC-123456).",
      "సరైన VPJC ఐడిని నమోదు చేయండి (ఉదా: VPJC-123456)."
    );
  }

  if (!form.previousVisit) {
    errors.previousVisit = validationMessage(
      "Please select Yes or No.",
      "దయచేసి అవును లేదా కాదు ఎంచుకోండి."
    );
  }

  if (!form.name.trim()) {
    errors.name = validationMessage(
      "Please enter the patient name.",
      "దయచేసి రోగి పేరు నమోదు చేయండి."
    );
  }

  const age = Number(form.age);

  if (
    form.age === "" ||
    !Number.isInteger(age) ||
    age < 0 ||
    age > 120
  ) {
    errors.age = validationMessage(
      "Please enter a valid age between 0 and 120.",
      "దయచేసి 0 నుండి 120 మధ్య సరైన వయస్సు నమోదు చేయండి."
    );
  }

  if (!form.gender) {
    errors.gender = validationMessage(
      "Please select the gender.",
      "దయచేసి లింగాన్ని ఎంచుకోండి."
    );
  }

  if (!form.patientType) {
    errors.patientType = validationMessage(
      "Please select the patient type.",
      "దయచేసి రోగి రకాన్ని ఎంచుకోండి."
    );
  }

  if (!form.patientCategory) {
    errors.patientCategory = validationMessage(
      "Please select the patient category.",
      "దయచేసి రోగి విభాగాన్ని ఎంచుకోండి."
    );
  }

  if (!form.paymentMode) {
    errors.paymentMode = validationMessage(
      "Please select the payment mode.",
      "దయచేసి చెల్లింపు విధానాన్ని ఎంచుకోండి."
    );
  }

  if (
    form.patientCategory === "Sponsor" &&
    !form.sponsorName.trim()
  ) {
    errors.sponsorName = validationMessage(
      "Please enter the sponsor name.",
      "దయచేసి స్పాన్సర్ పేరు నమోదు చేయండి."
    );
  }

  // Show required field errors
  if (Object.keys(errors).length > 0) {
    setFieldErrors(errors);
    setMessageType("error");
    setMessage(
      validationMessage(
        "Please correct the highlighted fields.",
        "దయచేసి గుర్తించిన ఫీల్డ్‌లను సరిచేయండి."
      )
    );
    return;
  }

  // Normalize input values
  const mobile = (form.residentialMobile || "").trim();
  const emergencyNumber = (form.emergencyContactNumber || "").trim();
  const permanentMobile = (form.permanentMobile || "").trim();
  const residentialPhone = (form.residentialPhone || "").trim();
  const permanentPhone = (form.permanentPhone || "").trim();
  const residentialPin = (form.residentialPin || "").trim();
  const permanentPin = (form.permanentPin || "").trim();
  const vpjcId = (form.vpjcId || "").trim();

  const mobilePattern = /^[6-9]\d{9}$/;
  const phonePattern = /^\d{10}$/;
  const pinCodePattern = /^\d{6}$/;

  if (mobile && !mobilePattern.test(mobile)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 10-digit residential mobile number starting with 6-9.",
      "6-9 అంకెలతో ప్రారంభమయ్యే సరైన 10 అంకెల నివాస మొబైల్ నంబర్ నమోదు చేయండి."
    ));
    return;
  }

  if (emergencyNumber && !mobilePattern.test(emergencyNumber)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 10-digit emergency contact number starting with 6-9.",
      "6-9 అంకెలతో ప్రారంభమయ్యే సరైన 10 అంకెల అత్యవసర సంప్రదింపు నంబర్ నమోదు చేయండి."
    ));
    return;
  }

  if (permanentMobile && !mobilePattern.test(permanentMobile)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 10-digit permanent mobile number starting with 6-9.",
      "6-9 అంకెలతో ప్రారంభమయ్యే సరైన 10 అంకెల శాశ్వత మొబైల్ నంబర్ నమోదు చేయండి."
    ));
    return;
  }

  if (residentialPhone && !phonePattern.test(residentialPhone)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 10-digit residential phone number.",
      "సరైన 10 అంకెల నివాస ఫోన్ నంబర్ నమోదు చేయండి."
    ));
    return;
  }

  if (permanentPhone && !phonePattern.test(permanentPhone)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 10-digit permanent phone number.",
      "సరైన 10 అంకెల శాశ్వత ఫోన్ నంబర్ నమోదు చేయండి."
    ));
    return;
  }

  if (residentialPin && !pinCodePattern.test(residentialPin)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 6-digit residential PIN code.",
      "సరైన 6 అంకెల నివాస పిన్ కోడ్ నమోదు చేయండి."
    ));
    return;
  }

  if (permanentPin && !pinCodePattern.test(permanentPin)) {
    setMessageType("error");
    setMessage(validationMessage(
      "Enter a valid 6-digit permanent PIN code.",
      "సరైన 6 అంకెల శాశ్వత పిన్ కోడ్ నమోదు చేయండి."
    ));
    return;
  }

  // Referral date validation
  if (
    form.referralStartDate &&
    form.referralEndDate &&
    form.referralEndDate < form.referralStartDate
  ) {
    setMessageType("error");
    setMessage(
      validationMessage(
        "Referral end date cannot be before the start date.",
        "రిఫరల్ ముగింపు తేదీ ప్రారంభ తేదీ కంటే ముందుగా ఉండకూడదు."
      )
    );
    return;
  }

  setSaving(true);

  try {
    const normalizedName = form.name.trim().toLowerCase();

    // Check duplicate name + mobile across both collections.
    const collectionNames = ["patients_regisgistration_form"];

if (mobile && !selectedExistingPatient) {
  // Prevent duplicate registration for a newly entered patient.
  const existingRegistrations = await getDocs(
    query(
      collection(db, "patients_regisgistration_form"),
      where("mobile", "==", mobile),
      where("normalized_name", "==", normalizedName)
    )
  );

  if (!existingRegistrations.empty) {
    setMessageType("error");
    setMessage(validationMessage(
      "A patient with this name and mobile number already exists. Please verify the existing record before proceeding.",
      "ఈ పేరు మరియు మొబైల్ నంబర్‌తో రోగి రికార్డు ఇప్పటికే ఉంది. కొనసాగించే ముందు ఉన్న రికార్డును తనిఖీ చేయండి."
    ));
    return;
  }
}

// Check VPJC ID only in registration collection.
if (vpjcId && !selectedExistingPatient) {
  const checkId = (collectionName) =>
    query(
      collection(db, collectionName),
      where("vpjc_id", "==", vpjcId)
    );

  const existingRegistrationIds = await getDocs(
    checkId("patients_regisgistration_form")
  );

  if (!existingRegistrationIds.empty) {
    setMessageType("error");
    setMessage(validationMessage(
      "This Patient VPJC ID already exists. Please enter a unique ID.",
      "ఈ VPJC రోగి ఐడి ఇప్పటికే ఉంది. దయచేసి వేరే ఐడి నమోదు చేయండి."
    ));
    return;
  }
}

    // Prepare registration data
    const patientData = {
      ...form,
      name: form.name.trim(),
      normalized_name: normalizedName,
      mobile,
      age,
      residentialPhone,
      permanentPhone,
      permanentMobile,
      emergencyContactNumber: emergencyNumber,
      residentialPin,
      permanentPin,
      vpjc_id: vpjcId,
      visit_count: 0,
      registration_source: "digital-registration-form",
      updated_at: serverTimestamp(),
    };

    // Update the selected registration record, or create the first registration record.
    if (selectedRegistrationId) {
      await updateDoc(
        doc(db, "patients_regisgistration_form", selectedRegistrationId),
        { ...patientData, updated_at: serverTimestamp() }
      );
    } else {
      await addDoc(
        collection(db, "patients_regisgistration_form"),
        { ...patientData, created_at: serverTimestamp() }
      );
    }

    setMessageType("success");
    setMessage(
      validationMessage(
        "Your patient registration has been successfully submitted. The details have been saved.",
        "మీ రోగి నమోదు విజయవంతంగా పూర్తయింది. వివరాలు భద్రపరచబడ్డాయి."
      )
    );

      setShowSuccessModal(true);
      setMessage("");

      setForm(initialForm);
      clearSignature();
      setFieldErrors({});
      setSelectedRegistrationId("");
      setSelectedExistingPatient(false);
      setLookupResults([]);
      setLookupInput("");
      setTokenConfirmation(null);
      setSameAsResidential(false);
  } catch (error) {
    console.error("Patient registration error:", error);

    setMessageType("error");
    setMessage(
      validationMessage(
        "Unable to submit the registration. Please check your connection and Firebase permissions, then try again.",
        "నమోదు వివరాలను సమర్పించలేకపోయాము. మీ ఇంటర్నెట్ కనెక్షన్ మరియు Firebase అనుమతులను తనిఖీ చేసి మళ్లీ ప్రయత్నించండి."
      )
    );
  } finally {
    setSaving(false);
  }
};

  const showRegistrationFields =
    (form.previousVisit === "Yes" && selectedExistingPatient) ||
    (form.previousVisit === "No" && Boolean(tokenConfirmation));

  return (
    <div className="min-h-screen w-full min-w-0 overflow-x-clip bg-[#F5F7FB] text-slate-800">
      <header className="sticky top-0 z-40 w-full border-b border-slate-200 bg-white/95 shadow-sm backdrop-blur-md">
        <div className="mx-auto flex w-full max-w-5xl min-w-0 flex-col gap-3 px-3 py-3 sm:flex-row sm:items-center sm:justify-between sm:gap-4 sm:px-6">
          <div className="flex min-w-0 items-center gap-3">
            <img
              src="/VPJCLogo-New.png"
              alt="VPJC Logo"
              className="h-12 w-12 shrink-0 object-contain sm:h-14 sm:w-14"
            />
            <div className="min-w-0">
            <p className="break-words text-base font-bold leading-tight tracking-tight text-[#204080] sm:text-xl">
              Visakha Physiotherapy &amp; Jasti Chiropractic
            </p>

            <h1 className="mt-1 break-words text-xs font-medium leading-normal text-slate-500 sm:text-sm">
              {language === "te" ? "రోగి నమోదు" : "Patient Registration"}
            </h1>
          </div>
          </div>
          <div className="flex w-full shrink-0 justify-end sm:w-auto">
            <div className="flex items-center rounded-xl border border-slate-200 bg-slate-50 p-1">
              <button
                type="button"
                onClick={() => setLanguage("en")}
                className={`min-h-9 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 ${
                  language === "en"
                    ? "bg-[#204080] text-white shadow-sm"
                    : "text-slate-500 hover:bg-white"
                }`}
              >
                English
              </button>
              <button
                type="button"
                onClick={() => setLanguage("te")}
                className={`min-h-9 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 ${
                  language === "te"
                    ? "bg-[#204080] text-white shadow-sm"
                    : "text-slate-500 hover:bg-white"
                }`}
              >
                తెలుగు
              </button>
            </div>
          </div>
        </div>
      </header>

      <main className="mx-auto w-full max-w-5xl min-w-0 px-3 py-5 pb-28 sm:px-6 sm:py-8">
        <div className="mb-6">
          <p className="text-sm leading-6 text-slate-500">
            {language === "te"
              ? "ముందుగా మీరు ఇంతకు ముందు VPJC కి వచ్చారా లేదా ఎంచుకోండి. ఆ తర్వాతి దశలు మీ ఎంపిక ఆధారంగా చూపబడతాయి."
              : "First, tell us whether you have visited VPJC before. The next steps will appear based on your answer."}
          </p>
        </div>

        <form
          noValidate
          onSubmit={handleSubmit}
          className="space-y-6"
        >
          {/* Previous visit lookup / new-patient token flow */}
          {form.previousVisit === "Yes" && (
            <section className="rounded-2xl border border-blue-200 bg-white p-4 shadow-sm sm:p-6">
              <h3 className="font-bold text-[#204080]">
                {language === "te" ? "పాత రోగి వివరాలు వెతకండి" : "Find Existing Patient"}
              </h3>
              <p className="mt-1 text-sm text-slate-500">
                {language === "te"
                  ? "VPJC ID లేదా మొబైల్ నంబర్‌తో వెతకండి."
                  : "Search using the VPJC ID or registered mobile number."}
              </p>
              <div className="mt-4 flex flex-col gap-2 sm:flex-row">
                <input
                  value={lookupInput}
                  onChange={(e) => setLookupInput(e.target.value)}
                  placeholder={language === "te" ? "VPJC ID / మొబైల్ నంబర్" : "VPJC ID / Mobile Number"}
                  className={inputClass}
                />
                <button
                  type="button"
                  onClick={searchExistingPatient}
                  disabled={fetchingPatient}
                  className="min-h-11 shrink-0 rounded-lg bg-[#204080] px-5 text-sm font-semibold text-white disabled:opacity-60"
                >
                  {fetchingPatient
                    ? (language === "te" ? "వెతుకుతున్నాం..." : "Searching...")
                    : (language === "te" ? "వెతకండి" : "Search Patient")}
                </button>
              </div>
              {patientLookupStatus && (
                <p className="mt-3 text-sm text-slate-600" role="status">{patientLookupStatus}</p>
              )}
              {lookupResults.length > 0 && (
                <div className="mt-4 space-y-2">
                  {lookupResults.map((patient) => (
                    <button
                      key={patient._patientDocId || patient.vpjc_id}
                      type="button"
                      onClick={() => applyPatientDetails(patient)}
                      className="w-full rounded-xl border border-slate-200 p-3 text-left transition hover:border-[#204080] hover:bg-blue-50"
                    >
                      <span className="block font-semibold text-slate-800">{patient.name || "Unnamed patient"}</span>
                      <span className="mt-1 block text-xs text-slate-500">
                        {patient.vpjc_id || "No VPJC ID"} · {patient.mobile || patient.residentialMobile || "No mobile"}
                      </span>
                    </button>
                  ))}
                </div>
              )}
            </section>
          )}

          {form.previousVisit === "No" && (
            <section className="rounded-2xl border border-emerald-200 bg-white p-4 shadow-sm sm:p-6">
              <h3 className="font-bold text-[#204080]">
                {language === "te" ? "కొత్త రోగి టోకెన్" : "New Patient Token"}
              </h3>
              <p className="mt-1 text-sm text-slate-500">
                {language === "te"
                  ? "ముందుగా టోకెన్ రూపొందించండి. అదే VPJC ID ఈ రిజిస్ట్రేషన్‌లో ఉపయోగించబడుతుంది."
                  : "Generate the token first. The VPJC ID created there will be reused in this registration."}
              </p>
              {tokenConfirmation && (
                <p className="mt-3 rounded-lg bg-emerald-50 p-3 text-sm font-medium text-emerald-800">
                  {language === "te" ? "టోకెన్: " : "Token: "}
                  {tokenConfirmation.token} · {tokenConfirmation.vpjcId}
                </p>
              )}
              {!tokenConfirmation && (
                <button
                  type="button"
                  onClick={() => navigate("/token", {
                    state: {
                      registrationFlow: true,
                      returnPath: location.pathname,
                      registrationDraft: form,
                    },
                  })}
                  className="mt-4 min-h-11 rounded-lg bg-[#204080] px-5 text-sm font-semibold text-white hover:bg-[#183365]"
                >
                  {language === "te" ? "టోకెన్ రూపొందించండి" : "Generate Token"}
                </button>
              )}
            </section>
          )}

          {sections
            .filter((section) =>
              showRegistrationFields || section.title === "Patient Details"
            )
            .filter((section) =>
              section.title !== "Insurance / Sponsor Information" ||
              form.patientCategory === "Sponsor"
            )
            .map((section) => (
            <section
              key={section.title}
              className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm"
            >
              <div className="border-b border-slate-200 bg-[#F7F9FD] px-4 py-4 sm:px-6">
                <h3 className="font-bold text-[#204080]">
                {language === "te"
                    ? section.teTitle || section.title
                    : section.title}
                </h3>
              </div>

              <div className="grid grid-cols-1 gap-4 p-4 sm:p-6 md:grid-cols-2">
                {section.fields
                  .filter((field) =>
                    showRegistrationFields || field.name === "previousVisit"
                  )
                  .map((field) => (
                  <Fragment key={field.name}>
                    {field.name === "permanentAddress" && section.title === "Address Information" && (
                      <div className="col-span-full">
                        <label className="flex items-center gap-2 text-sm font-medium text-[#204080]">
                          <input
                            type="checkbox"
                            checked={sameAsResidential}
                            onChange={(e) => {
                              const checked = e.target.checked;
                              setSameAsResidential(checked);

                              if (checked) {
                                setForm((prev) => ({
                                  ...prev,
                                  permanentAddress: prev.residentialAddress,
                                  permanentCity: prev.residentialCity,
                                  permanentState: prev.residentialState,
                                  permanentPin: prev.residentialPin,
                                  permanentPhone: prev.residentialPhone,
                                  permanentMobile: prev.residentialMobile,
                                  permanentEmail: prev.residentialEmail,
                                }));
                              }
                            }}
                          />
                          Same as Residential Address
                        </label>
                      </div>
                    )}
                    {field.name.startsWith("permanent") && sameAsResidential
                      ? null
                      : ["emergencyContactPerson", "emergencyContactNumber", "referringDoctorHospital"].includes(field.name) && form.isMLC !== "Yes"
                        ? null
                        : field.name === "paymentMode" && form.patientCategory === "Sponsor"
                          ? null
                          : renderField(field)}
                  </Fragment>
                ))}
              </div>
            </section>
          ))}

          <div className="rounded-lg border border-amber-200 bg-amber-50 p-4 text-sm leading-6 text-amber-900">
            {language === "te"
              ? "18 సంవత్సరాల కంటే తక్కువ వయస్సు ఉన్న రోగులకు తల్లిదండ్రులు లేదా చట్టబద్ధ సంరక్షకుల సమ్మతి అవసరం. ఈ ఫారమ్‌ను ఉపయోగించే ముందు క్లినిక్‌తో సమ్మతి మరియు సంతకం విధానాన్ని నిర్ధారించండి."
              : "For patients under 18 years of age, consent must be provided by a parent or legal guardian. Confirm the required consent and signature workflow with the clinic before using this form in production."}
          </div>

          {message && (
            <div
              role="status"
              className={`rounded-lg p-4 text-sm ${
                messageType === "success"
                  ? "bg-green-50 text-green-800"
                  : "bg-red-50 text-red-700"
              }`}
            >
              {message}
            </div>
          )}

          <div className="flex flex-col-reverse gap-3 sm:flex-row sm:justify-end">
            <button
              type="button"
              disabled={saving}
              onClick={() => {
                setForm(initialForm);
                clearSignature();
                setMessage("");
                setFieldErrors({});
                setSelectedRegistrationId("");
                setSelectedExistingPatient(false);
                setLookupResults([]);
                setLookupInput("");
                setTokenConfirmation(null);
                setPatientLookupStatus("");
                setSameAsResidential(false);
              }}
              className="min-h-12 rounded-lg border border-slate-300 bg-white px-6 py-3 text-sm font-semibold text-slate-700 hover:bg-slate-100 disabled:opacity-60"
            >
              {language === "te" ? "ఫారమ్ క్లియర్ చేయండి" : "Clear Form"}
            </button>

            <button
              type="submit"
              disabled={saving}
              className="min-h-12 rounded-lg bg-[#204080] px-6 py-3 text-sm font-semibold text-white hover:bg-[#183365] disabled:cursor-not-allowed disabled:opacity-60"
            >
              {saving
              ? language === "te" ? "సమర్పిస్తోంది..." : "Submitting..."
              : language === "te" ? "నమోదు సమర్పించండి" : "Submit Registration"}
            </button>
          </div>
        </form>
      </main>

      {showSuccessModal && (
  <div className="fixed inset-0 z-[100] flex items-center justify-center bg-slate-950/60 px-4 backdrop-blur-sm">
    <div className="w-full max-w-md rounded-2xl bg-white p-8 text-center shadow-2xl">
      <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-emerald-50 ring-8 ring-emerald-50/50">
        <svg
          className="h-10 w-10 text-emerald-600"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <path d="M7 12.5l3.5 3.5L17.5 9" />
        </svg>
      </div>

      <h2 className="mt-6 text-2xl font-bold text-slate-900">
        {language === "te"
          ? "నమోదు పూర్తయింది!"
          : "Registration Completed!"}
      </h2>

      <p className="mt-3 text-base font-semibold text-[#204080]">
        {language === "te"
          ? "రోగి నమోదు విజయవంతంగా పూర్తయింది."
          : "Patient Registered Successfully"}
      </p>

      <p className="mt-2 text-sm leading-6 text-slate-500">
        {language === "te"
          ? "రోగి వివరాలు విజయవంతంగా భద్రపరచబడ్డాయి."
          : "The patient registration has been completed and the details have been successfully saved."}
      </p>

      <button
        type="button"
        onClick={() => setShowSuccessModal(false)}
        className="mt-7 min-h-12 w-full rounded-xl bg-[#204080] px-6 py-3 text-sm font-semibold text-white transition hover:bg-[#183365]"
      >
        {language === "te" ? "సరే" : "Done"}
      </button>
    </div>
  </div>
)}
    </div>
  );
}